import React from 'react';
import '../../styles/mobile-menu-toggle.css';

const MobileMenuToggle = ({ isOpen, onToggle }) => {
  return (
    <button 
      className={`mobile-menu-toggle ${isOpen ? 'open' : ''}`}
      onClick={onToggle}
      aria-label="Toggle navigation menu"
    >
      <span className="hamburger-line"></span>
      <span className="hamburger-line"></span>
      <span className="hamburger-line"></span>
    </button>
  );
};

export default MobileMenuToggle;